import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'day'
})
export class DayPipe implements PipeTransform {

  transform(value: any, month?: any): any {
    if (value && month !== -1) {
      if ([1,3,5,7,8,10,12].indexOf(Number(month)) > -1) {
        return Array.from(Array(31).keys(), n =>  n + 1);
      } else if (Number(month) === 2) {
        return Array.from(Array(28).keys(), n =>  n + 1);
      } else {
        return Array.from(Array(30).keys(), n =>  n + 1);
      }
    }
    return Array.from(Array(31).keys(), n =>  n + 1);
  }

}
